import { Location } from "@angular/common";
import { AfterViewChecked, Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { UploadRv } from "../../model/domain/UploadRv";
import { LoaderService } from "../../services/loader.service";
import { SnackbarService } from "../../services/snackbar.service";
import { TicketService } from "../../services/ticket.service";

@Component({
  selector: "app-upload-rv",
  templateUrl: "./upload-rv.component.html",
  styleUrls: ["./upload-rv.component.css"],
})
export class UploadRvComponent implements OnInit, AfterViewChecked {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private service: TicketService,
    private snackBarService: SnackbarService,
    private loaderService: LoaderService
  ) {}

  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  isEditing = false;
  canValidate = false;
  isReady = false;
  ngForm: NgForm;
  AccountManagers = [];
  fileList: File[] = [];
  file: File;

  model: UploadRv;

  afuConfig = null;

  validators = {};

  // Init
  ngOnInit() {
    this.validatorsInit();
    this.modelInit();
  }

  ngAfterViewChecked() {
    if (!this.isReady) {
      setTimeout(() => {
        if (!this.canEdit()) {
          Object.values(this.frm.controls).forEach((c) => {
            c.disable();
          });
        }
      }, 0);
      this.isReady = true;
    }
  }

  validatorsInit() {
    // Add validators
  }

  modelInit() {
    this.model = new UploadRv();
  }

  canEdit() {
    return true;
  }

  validateForm(f: NgForm): boolean {
    return true;
  }

  submit() {
    this.loaderService.addLoader();

    this.register(this.frm)
      .pipe(
        catchError((err) => {
          this.loaderService.removeLoader();

          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
          return throwError(err);
        })
      )
      .subscribe(
        (r) => {
          this.loaderService.removeLoader();

          const msg = 'Boleta cadastrada! Confirme os detalhes no monitor e encaminhe para análise.';

          this.snackBarService.open(msg, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
            duration: 10000,
          });
        },
        () => {}
      );
  }

  register(f: NgForm) {
    const editing = this.isEditing;

    if (!this.canEdit()) {
      return;
    }

    try {
      const isValid = this.validateForm(f);
      if (isValid) {
        let data = Object.assign({}, this.model);

        return this.sendSubmit(data, editing);
      }
    } catch (error) {
      return throwError(error);
    }
  }

  openFile(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      this.file = this.fileList[0];
    }
  }

  sendSubmit(data: UploadRv, editing: boolean = false) {
    data.fileBase64 = this.file;
    const method = this.service.VariableIncome.upload(data);

    return method
      .pipe(
        catchError((err) => {
          return throwError("Erro ao cadastrar a boleta.");
        })
      )
      .pipe(
        map((margin: UploadRv) => {
          const url = this.router.createUrlTree([this.model.id], {
            relativeTo: this.route,
          });
          this.location.go(url.toString());

          return this.model;
        })
      );
  }
}
